import React, { useState, useRef, useEffect, useContext } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Collapse from '@material-ui/core/Collapse'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import PropertyDetails from '../../PropertyListTable/PropertyDetails/PropertyDetails'
import listContext from '../../../Common/context/context'
import RemovePropertyFromList from '../../PropertyListTable/RemovePropertyFromList/RemovePropertyFromList'
import ExcludePropertyFromList from '../../PropertyListTable/ExcludePropertyFromList/ExcludePropertyFromList'
import {
    valueFormatter, totalDataCountExt, unitsTotalFormula, getUnitMixSource
} from '../../Utility/PropertyListUtility'
import SelectUnitMixSource from '../../PropertyUnitMix/SelectUnitMixSource/SelectUnitMixSource'

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
    borderTopUnset: {
        '& > *': {
            borderTop: 'unset',
        },
    },
    borderSpacing: {
        '& > *': {
            borderCollapse: 'separate',
            borderSpacing: '0px 25px',
        },
    },
})

const getAlignment = type => {
    let returnVal = 'left'
    if (type !== 'text') {
        returnVal = 'right'
    }

    return returnVal
}
let subjectPropertyId = []
const FloorPlanRow = props => {
    // console.log('props:::', props)
    const [source, setSource] = useState(props.row.sourcePreference || "")
    const { row, showAllDetails, columnsList, compType, rowIndex, FPUnitTypes, colSpan, deleteList, setDeleteList, propertyTypesArray } = props
    const { data, omniViewPropertyId, excludeProperty } = row
    const omniviewpropertyrent = data.omniviewpropertyrent
    const omniviewproperty = data.omniviewproperty[0]
    const [borderIndexes, setBorderIndexes] = React.useState([])
    const [filteredColumnsList, setFilteredColumnsList] = React.useState(columnsList)
    const { propertyList } = useContext(listContext)
    // let floorPlanData = []
    const [open, setOpen] = React.useState(false)
    const classes = useRowStyles()
    const detailsRef = useRef(null)
    // let fpColumns = floorPlanColumns   

    const getSourcePreference = () => {

        let returnVal = ''

        if (data && data.omniviewpropertyrent) {
            returnVal = getUnitMixSource({ 'compsList': [row] }, row.omniViewPropertyId)
        }
        return returnVal
    }

    const updateColumnList = () => {
        let modifiedColumnList = []
        let uniqueProperties = Array.from(new Set(propertyTypesArray))
        let propertyType = omniviewproperty.omniViewPropertyType === 'Student Housing' ? 'Student Housing' : 'NonStudentHousing'
        for (let index = 0; index < columnsList.length; index++) {
            if (uniqueProperties.length >= 1 && uniqueProperties.includes('Student Housing')) {
                if ((['propertyName', 'sourceLastModifiedDate', 'source'].includes(columnsList[index].fieldName)) || (columnsList[index] !== undefined && columnsList[index].if !== undefined && columnsList[index].if.includes(propertyType))) {
                    modifiedColumnList.push(columnsList[index])
                }
            } else if (uniqueProperties.length >= 1 && !(uniqueProperties.includes('Student Housing'))) {
                if ((['propertyName', 'sourceLastModifiedDate', 'source'].includes(columnsList[index].fieldName)) || (columnsList[index] !== undefined && columnsList[index].if !== undefined && !(columnsList[index].if.includes('Mixed')) && columnsList[index].if.includes(propertyType))) {
                    modifiedColumnList.push(columnsList[index])
                }
            }
        }
        setFilteredColumnsList(modifiedColumnList)
    }

    useEffect(() => {
        updateColumnList()
    }, [columnsList, propertyTypesArray])

    useEffect(() => {
        if (data && data.omniviewpropertyrent) {
            let newSource = getSourcePreference()
            setSource(newSource)
        }
    }, [row])

    useEffect(() => {
        setOpen(showAllDetails)
    }, [showAllDetails])

    // useEffect(() => {
    //     // setFPUnitTypesCount(FPUnitTypes.length)
    //     let indexes = []
    //     let index = 0

    //     for (let i = 0; i < FPUnitTypes.length; i++) {
    //         index += +FPUnitTypes.length
    //         indexes.push(index)
    //     }

    //     setBorderIndexes(indexes)
    // }, [FPUnitTypes])

    useEffect(() => {
        // setFPUnitTypesCount(FPUnitTypes.length)
        let indexes = []
        let index = 0

        for (let i = 0; i < FPUnitTypes.length; i++) {
            index += +colSpan
            indexes.push(index)
        }
        // console.log('indexes = ', colSpan)
        setBorderIndexes(indexes)
    }, [colSpan, FPUnitTypes])

    const getFloorPlanData = rowParam => {

        let returnVal = ''

        // let unitType = rowParam.unitType.toLowerCase() === 'studio' ?
        try {
            let rentData = omniviewpropertyrent.filter(x => x.unitType.includes(rowParam.unitType))

            if (rowParam && rowParam.unitType && rowParam.unitType.toLowerCase() === '0 bedroom') {
                rentData = omniviewpropertyrent.filter(x => x.unitType.includes(rowParam.unitType) || x.unitType.includes('Studio'))
            }

            if (rentData.length == 0) { return returnVal }

            rentData.forEach(element => {
                element.monthlyEffectiveRent = element.effectiveRent * element.units
            });

            switch (rowParam.fieldName) {
                case 'units':
                    returnVal = totalDataCountExt('units', rentData, omniviewproperty.source, false)
                    break
                case 'beds':
                    returnVal = totalDataCountExt('beds', rentData, omniviewproperty.source, false)
                    break
                case 'unitSize':
                    returnVal = unitsTotalFormula(totalDataCountExt('totalSize', rentData, omniviewproperty.source, false), totalDataCountExt('units', rentData, omniviewproperty.source, false))
                    break
                case 'unitMarketRent':
                    returnVal = unitsTotalFormula(totalDataCountExt('monthlyMarketRent', rentData, omniviewproperty.source, false), totalDataCountExt('units', rentData, omniviewproperty.source, false))
                    returnVal = returnVal.toFixed(0)
                    break
                case 'marketRentPerSF':
                    returnVal = unitsTotalFormula(totalDataCountExt('monthlyMarketRent', rentData, omniviewproperty.source, false), totalDataCountExt('totalSize', rentData, omniviewproperty.source, false))
                    break
                case 'effectiveRent':
                    returnVal = unitsTotalFormula(totalDataCountExt('monthlyEffectiveRent', rentData, omniviewproperty.source, false), totalDataCountExt('units', rentData, omniviewproperty.source, false))
                    returnVal = returnVal.toFixed(0)
                    break
                case 'effectiveRentPerSF':
                    returnVal = unitsTotalFormula(totalDataCountExt('monthlyEffectiveRent', rentData, omniviewproperty.source, false), totalDataCountExt('totalSize', rentData, omniviewproperty.source, false))
                    break
                case 'mrBed':
                    returnVal = unitsTotalFormula(totalDataCountExt('monthlyMarketRent', rentData, omniviewproperty.source, false), totalDataCountExt('beds', rentData, omniviewproperty.source, false))
                    returnVal = returnVal.toFixed(0)
                    break
                default: break
            }
        } catch (error) {
            console.log('error in  getFloorPlanData = ', error)
        }

        return returnVal
    }

    const getAddress = () => {
        let address = ''

        try {
            address = `${omniviewproperty.addressLine1} ${omniviewproperty.city ? omniviewproperty.city : ''}, ${omniviewproperty.state ? omniviewproperty.state : ''}, ${omniviewproperty.zipCode ? omniviewproperty.zipCode : ''}`
            address = address.replace(',,', ',')
            address = address.replace(', ,', ',')
        } catch (error) {

        }

        return address
    }

    const getFieldValue = rowParam => {
        let returnVal = '-'

        try {
            if (rowParam.dataObj === 'omniviewproperty' && omniviewproperty[rowParam.fieldName]) {
                returnVal = omniviewproperty[rowParam.fieldName]
            }
            else {
                returnVal = getFloorPlanData(rowParam)
            }

            returnVal = returnVal.toString()
            returnVal = valueFormatter(returnVal, rowParam.type)

        } catch (error) {
            console.log('error in getFieldValue in floorplanrow.js ::', error)
        }

        return returnVal
    }

    const handleClick = (event, omniViewPropertyId) => {
        let index;
        let checkedValue = event.target.checked

        if (checkedValue === true) {
            if (deleteList.indexOf(omniViewPropertyId) === -1) {
                setDeleteList([...deleteList, omniViewPropertyId])
            }
        }
        else {
            index = deleteList.indexOf(omniViewPropertyId);
            let tempDeleteList = [...deleteList]
            if (index > -1) {
                tempDeleteList.splice(index, 1);
                setDeleteList(tempDeleteList)
            }
        }
    }

    if (propertyList) {
        for (let i = 0; i < propertyList.compsList.length; i++) {
            if (propertyList.compsList[i].isSubjectProperty === true) {
                if (subjectPropertyId.indexOf(propertyList.compsList[i].omniViewPropertyId) === -1) {
                    subjectPropertyId.push(propertyList.compsList[i].omniViewPropertyId)
                }
            }
        }
    }

    const checkSubjectPropertyId = (omniViewPropertyId) => {
        let value = false;
        for (let i = 0; i < subjectPropertyId.length; i++) {
            if (subjectPropertyId[i] === omniViewPropertyId) {
                return true;
            }
            else value = false;
        }
        return value;
    }

    return (
        <React.Fragment>
            <TableRow id={omniViewPropertyId}
                draggable={isNaN(rowIndex) ? false : true}
                className={` drag-row ${classes.borderTopUnset}`}  >
                {filteredColumnsList.map((row, index) => (
                    <TableCell className={`text-1 ${borderIndexes.includes(index) ? 'border-r-1 border-base' : ''} ${row.fieldName === 'propertyName' ? 'sticky-left pr-0' : ''} `} align={getAlignment(row.type)}>
                        <div className={`flex flex-col ${row.fieldName === 'propertyName' ? 'border-r-1 border-base' : ''}`}>
                            {row.fieldName === 'propertyName' ?
                                <>
                                    <div className="flex flex-row">
                                        <div className="mr-4 mt-3 ml-3">
                                            <span>
                                                <input type="checkbox" disabled={checkSubjectPropertyId(omniViewPropertyId)}
                                                    onClick={(event) => handleClick(event, omniViewPropertyId)} value={omniViewPropertyId}
                                                />
                                            </span>
                                        </div>
                                        <div className="mr-5 mt-3">
                                            {isNaN(rowIndex) ?
                                                <span className="bg-gray-80 text-white p-3 mr-3 rounded-1">{rowIndex}</span>
                                                : <span className=" p-3 px-4 mr-3 rounded-1">{rowIndex}</span>}
                                        </div>
                                        <div className="pr-4 flex flex-col">
                                            <span className={`${excludeProperty ? 'text-disabled' : ''} truncate`} >
                                                {excludeProperty ? <span className="text-1">{getFieldValue(row)}</span> :
                                                    <a href={`${window.REACT_GLOBAL_CONFIG.SF_URL}${omniViewPropertyId}`} target="_blank" rel="noopener noreferrer">{getFieldValue(row)}</a>}
                                            </span>
                                            <span className={`truncate ${excludeProperty ? 'text-disabled' : 'text-1 text-muted truncate'} `}>{getAddress()}</span>
                                        </div>
                                    </div>
                                </>
                                :
                                <>
                                    {row.fieldName === 'source' ?
                                        <span className="">
                                            <SelectUnitMixSource source={source} setSource={setSource} propertyId={omniViewPropertyId}></SelectUnitMixSource>
                                        </span>
                                        :
                                        <span className={`truncate ${excludeProperty ? 'text-disabled' : ''}`}>
                                            {data.omniviewpropertyrent ?
                                                getFieldValue(row)
                                                : '-'}
                                        </span>}
                                    <span className={`truncate ${excludeProperty ? 'text-disabled' : 'text-1 text-muted truncate'} `}>
                                        {row.fieldName === 'source' ? '' : row.label}
                                    </span>
                                </>
                            }
                        </div>
                    </TableCell>
                ))}
                <TableCell className='sticky-right pl-0'>
                    <div className="space-x-4 space-x-reverse border-l-1 border-base flex flex-row-reverse">
                        <button title="Expand" ref={detailsRef} aria-label="expand row" className={`btn btn-sm ${open ? 'text-primary' : ''}`} onClick={() => setOpen(!open)}>
                            {open ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                        </button>
                        {!row.isSubjectProperty ?
                            <RemovePropertyFromList propertyId={omniViewPropertyId} omniViewPropertyListId={propertyList.omniViewPropertyListId} polarisPropertySearchCriteriaId={propertyList.polarisPropertySearchCriteriaId} />
                            : null}
                        {!row.isSubjectProperty ?
                            <ExcludePropertyFromList propertyId={omniViewPropertyId} />
                            : null}
                    </div>
                </TableCell>
            </TableRow>
            <TableRow className={` ${open ? '' : classes.root}`}>
                <TableCell style={{ padding: 0, }} colSpan={filteredColumnsList.length + 1}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <PropertyDetails row={row} compType={compType} source={source}></PropertyDetails>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment >
    )
}

FloorPlanRow.propTypes = {
    row: PropTypes.any,
    showAllDetails: PropTypes.any,
    columnsList: PropTypes.any,
    compType: PropTypes.any,
    rowIndex: PropTypes.any,
    colSpan: PropTypes.any,
    propertyTypesArray: PropTypes.any,
}

export default FloorPlanRow
